<template>
  <div>
    <div class="section">
      <div class="row">
        <div class="section_image">
          <!--  -->
          <div class="image-preview" v-if="imageData[0] != undefined" style="position: relative; width: 12rem!important; height: 12rem;">
            <div class="removeimage" v-if="configInputs == 0">
                <div></div>
                <label class="palavra" @click="resetFile(0)">
                  <div class="closeimage"></div>
                </label>
              </div>
            <img
              class="container"
              :src="`${imageData[0]}`"
              @click="clickPreview(imageData[0])"
              alt=""
            />
          </div>

          <div class="image-preview" v-else>
            <div v-if="configInputs==0">
              <input
                    type="file"
                    accept="image/*"
                    @change="previewFiles($event, 0)"
                    id="FotodaFacedoLadoFixoPreview"
                    multiple
                    hidden
              />
              <label class="palavra" for="FotodaFacedoLadoFixoPreview">
                <div class="palavra1"></div>
              </label>
            </div>
            <div v-else>
              <div class="empty"></div>
            </div>
          </div>

          <!--  -->
          <div>
            <p class="title">Foto da Face do Lado Fixo</p>
          </div>
        </div>

        <div class="section_image">
          <!--  -->
          <div class="image-preview" v-if="imageData[1] != undefined" style="position: relative; width: 12rem!important; height: 12rem;">
            <div class="removeimage" v-if="configInputs == 0">
                <div></div>
                <label class="palavra" @click="resetFile(1)">
                  <div class="closeimage"></div>
                </label>
              </div>
            <img
              class="container"
              :src="`${imageData[1]}`"
              @click="clickPreview(imageData[1])"
              alt=""
            />
          </div>

          <div class="image-preview" v-else>
            <div v-if="configInputs==0">
              <input
                      type="file"
                      accept="image/*"
                      @change="previewFiles($event, 1)"
                      id="FotodaFacedoLadoMovelPreview"
                      multiple
                      hidden
                />
                <label class="palavra" for="FotodaFacedoLadoMovelPreview">
                  <div class="palavra1"></div>
                </label>
            </div>
              <div v-else>
                <div class="empty"></div>
              </div>
          </div>

          <!--  -->

          <div>
            <p class="title">Foto da Face do Lado Móvel</p>
          </div>
        </div>

        <div class="section_image" style="text-align: center!important;">
          <!--  -->
          <div class="image-preview" v-if="imageData[2] != undefined" style="position: relative; width: 12rem!important; height: 12rem;">
            <div class="removeimage" v-if="configInputs == 0">
              <div class="closeimage" @click="resetFile(2)"></div>
            </div>
            <img
              class="container"
              :src="`${imageData[2]}`"
              @click="clickPreview(imageData[2])"
              alt=""
            />
          </div>

          <div class="image-preview" v-else>
            <div v-if="configInputs==0">
              <input
                      type="file"
                      accept="image/*"
                      @change="previewFiles($event, 2)"
                      id="fotoMoldeAbertoExtraPreview"
                      multiple
                      hidden
                />
                <label class="palavra" for="fotoMoldeAbertoExtraPreview">
                  <div class="palavra1"></div>
                </label>
            </div>
              <div v-else>
                <div class="empty"></div>
              </div>
          </div>

          <!--  -->
          <div>
             <div v-if="configInputs == 0">
              <input type="text" class="extra-input" v-model="FormDataImages.fotoMoldeAbertoExtra.description" placeholder="Insira um título" />
             </div>
             <div v-else>
            <p class="title" v-if="!this.FormDataImages.fotoMoldeAbertoExtra.description">Extra</p>
            <p class="title" v-else>{{this.FormDataImages.fotoMoldeAbertoExtra.description}}</p>
             </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputI1 from "../../../../../Inputs-defaults/Inp-1.vue";
export default {
  components: { InputI1 },
  props: {
    configInputs: Number,
  },
  async created() {
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
  data() {
    return {
      imageData: [],

      FormDataImages: {
        FotodaFacedoLadoFixoFile: [],
        FotodaFacedoLadoMovelFile: [],
        fotoMoldeAbertoExtra: {
          file: [],
          description: "",
        },
      },
    };
  },

  watch: {
    FormDataImages: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.$store.commit("MutationImagesMoldeAberto", newValue);
      },
    },
  },
  methods: {
    clickPreview(base64) {
      this.$swal.fire({
          imageUrl: base64,
          imageAlt: "Imagem carregada",
          confirmButtonText: 'Baixar',
          showCloseButton: true,
          background: "#fff",
          customClass: {
              popup: 'preview-modal-popup',
              image: 'preview-modal-image',
              confirmButton: 'preview-modal-button'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            const link = document.createElement('a');
            link.href = base64;
            link.download = 'imagem.jpg'; 
            link.click();
          }
      });
    },
    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;
      if (dataQuery.ImagesRRIM[0].IMG_MA_F_L_FIXO) {
        this.imageData[0] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MA_F_L_FIXO}`;
        this.FormDataImages.FotodaFacedoLadoFixoFile =
          dataQuery.ImagesRRIM[0].IMG_MA_F_L_FIXO;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MA_F_L_MOVEL) {
        this.imageData[1] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MA_F_L_MOVEL}`;
        this.FormDataImages.FotodaFacedoLadoMovelFile =
          dataQuery.ImagesRRIM[0].IMG_MA_F_L_MOVEL;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MA_EXTRA) {
        this.imageData[2] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_MA_EXTRA}`;
        this.FormDataImages.fotoMoldeAbertoExtra.file =
          dataQuery.ImagesRRIM[0].IMG_MA_EXTRA;
      }
      if (dataQuery.ImagesRRIM[0].IMG_MA_EXTRA_DESC) {

          this.FormDataImages.fotoMoldeAbertoExtra.description =
          dataQuery.ImagesRRIM[0].IMG_MA_EXTRA_DESC ;
      }
    },

    previewFiles(event, position) {
      const input = event.target;

      if (input.files && input.files[0]) {
        const file = input.files[0];

        if (!file.type.startsWith("image/")) {
          this.$swal.fire({
            icon: "error",
            title: "Arquivo inválido",
            text: "Por favor, selecione apenas arquivos de imagem.",
            confirmButtonColor: "#e74c3c",
          });
          input.value = ""; 
          return;
        }

        switch (position) {
          case 0:
            this.FormDataImages.FotodaFacedoLadoFixoFile = file;
            break;
          case 1:
            this.FormDataImages.FotodaFacedoLadoMovelFile = file;
            break;
          case 2:
            this.FormDataImages.fotoMoldeAbertoExtra.file = file;
            break;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData[position] = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    resetFile(position) {
      this.imageData[position] = null;

      switch (position) {
        case 0:
          this.FormDataImages.FotodaFacedoLadoFixoFile = [];
          break;
        case 1:
          this.FormDataImages.FotodaFacedoLadoMovelFile = [];
          break;
        case 2:
          this.FormDataImages.fotoMoldeAbertoExtra.file = [];
          this.FormDataImages.fotoMoldeAbertoExtra.description = "";
          break;
      }
    },
  },
};
</script>

<style scoped>
.swal2-image.original-size-image {
  max-width: 90vw;
  max-height: 80vh;
  width: auto;
  height: auto;
  border-radius: 1rem;
}

.container {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center; 
  border-radius: 1rem;
  border: 2px solid #ccc;
  cursor: pointer;
}

.section {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  flex-wrap:wrap;
  row-gap: 2rem;  
  flex-direction: column;
  flex-wrap: wrap;
}

.title {
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  margin-top: 0.5rem;
}

.section_image {
  display: inline-block;
  max-width: 11rem!important;

}

.palavra {
  width: 12rem !important;
}

.palavra1 {
  background-color: var(--bgProcess);
  background-image: url(../../../../../../static/icons/+_black.svg);
  width: 12rem !important;
  height: 12rem !important;
  border-radius: 1rem;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 15%;
}

.palavra1:hover{
  background-color: rgb(156, 150, 150);
}



.image-preview {
  position: relative;
}

.removeimage {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 3;
  cursor: pointer;
}

#fotoEmbalagemPreview {
  position: relative;
  z-index: 2;
  border-radius: 1rem;
}

.closeimage {
  width: 24px;
  height: 24px;
  background: url(../../../../../../static/icons/closeimage.svg) no-repeat center;
  background-size: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  cursor: pointer;
}

.extra-input {
  border: 2px solid var(--bgProcess)!important;
  background-color: rgba(255, 255, 255, 0);
  padding: 0.3rem!important;
  height: 2rem!important;
  margin: 1rem auto!important;
  color: var(--font_color);
  font-weight: 600;
  font-family: 'Poppins', 'sans-serif';
  border-radius: 0.5rem;
  max-width: 92%;
}

.extra-input:hover {
  border: 2px solid var(--graydark)!important;
  transition: 1s;
}

.extra-input:focus{
  border: 2px solid var(--font_color)!important;
  transition: 1s;
}


.container {
  border-radius: 0.8rem!important
}

.row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
}

.empty {
  background-image: url('../../../../../../static/icons/empty-image.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 40%;
  width: 12rem;
  height: 12rem;
  border: 2px solid #757575;
  border-radius: 1rem;
}


</style>
